import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useClientAuth } from "@/context/ClientAuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setClient } = useClientAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/account/login", { replace: true }); return; }
    (async () => {
      try {
        const r = await api.post("/client/google-session", { session_id: match[1] });
        setClient(r.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Google sign-in failed");
        setTimeout(() => navigate("/account/login", { replace: true }), 2500);
      }
    })();
  }, [navigate, setClient]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-[#D4A62A] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm text-[#4B5563]" data-testid="auth-callback-status">{error || "Signing you in…"}</p>
      </div>
    </div>
  );
}
